import { ParlorDetailProps } from "@/types/parlor";
import { FUNERAL_SIDO, FUNERAL_SIGUNGU } from "goi_common";

const howtoRichSearch = (defaultParlor: ParlorDetailProps) => {
  return {
    "@context": "https://schema.org",
    "@type": "HowTo",
    name: `${FUNERAL_SIDO.get(Number(defaultParlor.sido)) as string} 지역 ${`${
      FUNERAL_SIGUNGU.get(Number(defaultParlor.sido))?.get(Number(defaultParlor.sigungu)) as string
    }`}장례식장, 잘 고르는 방법.(${defaultParlor.companyname})`,
    step: [
      {
        "@type": "HowToStep",
        url: `https://www.goifuneral.co.kr/information-price/parlor/${defaultParlor.id}`,
        name: "무빈소 장례 예상 비용",
        image: {
          "@type": "ImageObject",
          url: "https://goifuneral.mo.cloudinary.net/platform/prepare/prepare-1-1.png",
          height: "420",
          width: "368",
        },
        text: `${defaultParlor.expected_charge_sum.무빈소.toLocaleString()}원`,
      },
      {
        "@type": "HowToStep",
        url: `https://www.goifuneral.co.kr/information-price/parlor/${defaultParlor.id}`,
        name: "조문객 50명 장례 예상 비용",
        image: {
          "@type": "ImageObject",
          url: "https://goifuneral.mo.cloudinary.net/platform/prepare/prepare-1-2.png",
          height: "420",
          width: "368",
        },
        text: `${defaultParlor.expected_charge_sum.가족장.toLocaleString()}원`,
      },
      {
        "@type": "HowToStep",
        url: `https://www.goifuneral.co.kr/information-price/parlor/${defaultParlor.id}`,
        name: "조문객 200명 장례 예상 비용",
        image: {
          "@type": "ImageObject",
          url: "https://goifuneral.mo.cloudinary.net/platform/prepare/prepare-1-3.png",
          height: "420",
          width: "368",
        },
        text: `${defaultParlor.expected_charge_sum.일반장.toLocaleString()}원`,
      },
    ],
    totalTime: "P7D",
  };
};

export const informationPriceRichSearch = { howtoRichSearch };
